export const osspath = 'https://kindstarbiotech.oss-cn-hangzhou.aliyuncs.com/'

export const appid = 'wx284f6b189496a42e'  //测试环境